"use client";

import { useState } from "react";
import styles from "./ui.module.css";

// Término con ayuda al pasar el cursor, al enfocar o al tocar (nada depende de hover).
export function Term({ children, help }: { children: React.ReactNode; help: string }) {
  const [open, setOpen] = useState(false);
  return (
    <span
      className={styles.term}
      tabIndex={0}
      role="button"
      aria-expanded={open}
      onClick={() => setOpen((v) => !v)}
      onBlur={() => setOpen(false)}
      onKeyDown={(e) => {
        if (e.key === "Escape") setOpen(false);
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setOpen((v) => !v);
        }
      }}
      data-open={open ? "true" : undefined}
    >
      {children}
      <span className={styles.tip} role="tooltip">
        {help}
      </span>
    </span>
  );
}
